var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
import { __decorate, __metadata } from "tslib";
import rotService from "@/core/services/rotService";
import JwtService from "@/core/services/JwtService";
import { Mutations } from "@/store/enums/StoreEnums";
import { Etapa_Fluxo_InspecaoActions } from "@/store/enums/rotEnums";
import { Module, Action, VuexModule } from "vuex-module-decorators";
let Etapa_Fluxo_InspecaoModule = class Etapa_Fluxo_InspecaoModule extends VuexModule {
    constructor() {
        super(...arguments);
        this.errors = {};
        this.isAuthenticated = !!JwtService.getToken();
    }
    [_a = Etapa_Fluxo_InspecaoActions.DOWNLOAD_PLANILHA]() {
        return new Promise((resolve, reject) => {
            rotService.getFile("Etapa_Fluxo_Inspecao/DownloadPlanilhaModelo")
                .then((response) => {
                const blob = new Blob([response.data], {
                    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                });
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'Planilha_Modelo_Etapa_Fluxo_Inspecao.xlsx');
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                resolve(response);
            })
                .catch((error) => {
                if (error.response) {
                    this.context.commit(Mutations.SET_ERROR, error.response.data.errors);
                    reject(error.response.data.errors);
                }
                else {
                    reject("Erro ao baixar a planilha.");
                }
            });
        });
    }
    [_b = Etapa_Fluxo_InspecaoActions.UPLOAD_PLANILHA](file) {
        const formData = new FormData();
        formData.append('file', file); // Adiciona o arquivo ao FormData
        return new Promise((resolve, reject) => {
            rotService.postFile("Etapa_Fluxo_Inspecao/ImportarPlanilha", formData)
                .then(({ data }) => {
                resolve(data); // Sucesso
            })
                .catch((error) => {
                if (error.response) {
                    this.context.commit(Mutations.SET_ERROR, error.response.data.errors);
                    reject(error.response.data.errors); // Rejeita com o erro
                }
                else {
                    reject("Erro ao enviar a planilha.");
                }
            });
        });
    }
    [_c = Etapa_Fluxo_InspecaoActions.POST_ETAPA_FLUXO_INSPECAO](data) {
        return new Promise(resolve => {
            rotService.post("Etapa_Fluxo_Inspecao/Post", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_d = Etapa_Fluxo_InspecaoActions.PUT_ETAPA_FLUXO_INSPECAO](data) {
        return new Promise(resolve => {
            rotService.put("Etapa_Fluxo_Inspecao/Put", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_e = Etapa_Fluxo_InspecaoActions.DELETE_ETAPA_FLUXO_INSPECAO](data) {
        return new Promise(resolve => {
            rotService.delete("Etapa_Fluxo_Inspecao/Delete", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_f = Etapa_Fluxo_InspecaoActions.DELETE_RANGE_ETAPA_FLUXO_INSPECAO](data) {
        return new Promise(resolve => {
            rotService.delete("Etapa_Fluxo_Inspecao/DeleteRange", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_g = Etapa_Fluxo_InspecaoActions.FILTER_ETAPA_FLUXO_INSPECAO](data) {
        return new Promise(resolve => {
            rotService.post("Etapa_Fluxo_Inspecao/Filter", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_h = Etapa_Fluxo_InspecaoActions.GET_ETAPA_FLUXO_INSPECAO]() {
        return new Promise(resolve => {
            rotService.get("Etapa_Fluxo_Inspecao/Get")
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_j = Etapa_Fluxo_InspecaoActions.GETWITHDISABLED_ETAPA_FLUXO_INSPECAO]() {
        return new Promise(resolve => {
            rotService.get("Etapa_Fluxo_Inspecao/GetWithDisabled")
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
    [_k = Etapa_Fluxo_InspecaoActions.GET_BY_ID_ETAPA_FLUXO_INSPECAO](data) {
        return new Promise(resolve => {
            rotService.get("Etapa_Fluxo_Inspecao/GetById", data)
                .then(({ data }) => {
                resolve(data);
            })
                .catch(({ response }) => {
                this.context.commit(Mutations.SET_ERROR, response.data.errors);
            });
        });
    }
};
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], Etapa_Fluxo_InspecaoModule.prototype, _a, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [File]),
    __metadata("design:returntype", void 0)
], Etapa_Fluxo_InspecaoModule.prototype, _b, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Etapa_Fluxo_InspecaoModule.prototype, _c, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Etapa_Fluxo_InspecaoModule.prototype, _d, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Etapa_Fluxo_InspecaoModule.prototype, _e, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Etapa_Fluxo_InspecaoModule.prototype, _f, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Etapa_Fluxo_InspecaoModule.prototype, _g, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], Etapa_Fluxo_InspecaoModule.prototype, _h, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], Etapa_Fluxo_InspecaoModule.prototype, _j, null);
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], Etapa_Fluxo_InspecaoModule.prototype, _k, null);
Etapa_Fluxo_InspecaoModule = __decorate([
    Module
], Etapa_Fluxo_InspecaoModule);
export default Etapa_Fluxo_InspecaoModule;
//# sourceMappingURL=Etapa_Fluxo_InspecaoModule.js.map